export default __webpack_public_path__ + "static/Agile-Bold-13f33d30aea16417702bb49942573594.ttf";